import { render, staticRenderFns } from "./PromoteMonthlyGoalsDetail.vue?vue&type=template&id=3729bf7c"
import script from "./PromoteMonthlyGoalsDetail.vue?vue&type=script&lang=js"
export * from "./PromoteMonthlyGoalsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports